
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","fill":"none","viewBox":"0 0 16 16"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('circle',{attrs:{"cx":"8","cy":"8","r":"8","fill":"currentColor"}}),_c('path',{attrs:{"fill":"#F7FCFF","d":"M11.75 6.75h-.375V4.875C11.375 3.01392 9.86108 1.5 8 1.5S4.625 3.01392 4.625 4.875V6.75H4.25c-.82842 0-1.5.67153-1.5 1.5V12c0 .8284.67158 1.5 1.5 1.5h7.5c.8284 0 1.5-.6716 1.5-1.5V8.25c0-.82847-.6716-1.5-1.5-1.5zM6.125 4.875C6.125 3.84082 6.9662 3 8 3s1.875.84082 1.875 1.875V6.75h-3.75V4.875z"}})])
          )
        }
      }
    